import { render } from "./RssFeedDetailVx.vue?vue&type=template&id=7bf97a72"
import script from "./RssFeedDetailVx.vue?vue&type=script&lang=js"
export * from "./RssFeedDetailVx.vue?vue&type=script&lang=js"

import "./RssFeedDetailVx.vue?vue&type=style&index=0&id=7bf97a72&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__